<template>
  <b-modal
    ref="userSettingsModal"
    :title="$t('topbar.settings.title')"
    hide-footer
    size="md"
    @hidden="onHidden"
  >
    <div v-if="userSettings" class="tw-py-2">
      <settings-form
        :settings="userSettings"
        :options="settingsOptions"
        @save="onSave"
      />
    </div>
    <div v-else class="text-center py-4">
      <img alt="loading" height="40px" src="@assets/images/loading.svg" />
    </div>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex';
import SettingsForm from '@components/global/SettingsForm.vue';

export default {
  name: 'UserSettingsModal',
  components: { SettingsForm },

  computed: {
    ...mapState({
      userSettings: state => state.settings.userSettings,
      showSettingsModal: state => state.settings.showSettingsModal,
    }),

    settingsOptions() {
      return [
        {
          key: 'mobile_feed_notifications',
          type: 'toggle',
          label: this.$t('topbar.settings.mobileFeed.label'),
          description: this.$t('topbar.settings.mobileFeed.description'),
          componentId: 'mobile-feed-toggle',
        },
        {
          key: 'ai_prompts',
          type: 'toggle',
          label: this.$t('topbar.settings.aiPrompts.label'),
          description: this.$t('topbar.settings.aiPrompts.description'),
          componentId: 'ai-prompts-toggle',
        },
        {
          key: 'chat_bot',
          type: 'toggle',
          label: this.$t('topbar.settings.chatBot.label'),
          description: this.$t('topbar.settings.chatBot.description'),
          componentId: 'chat-bot-toggle',
        },
        {
          key: 'prolipsis_widget',
          type: 'toggle',
          label: this.$t('topbar.settings.prolipsisWidget.label'),
          description: this.$t('topbar.settings.prolipsisWidget.description'),
          componentId: 'prolipsis-widget-toggle',
        },
        {
          key: 'client_file_uploads',
          type: 'toggle',
          label: this.$t('topbar.settings.clientFileUploads.label'),
          description: this.$t('topbar.settings.clientFileUploads.description'),
          componentId: 'client-file-uploads-toggle',
        },
      ];
    },
  },

  watch: {
    showSettingsModal(val) {
      if (val) {
        this.$store.dispatch('settings/fetchSettings').then(() => {
          this.$refs.userSettingsModal.show();
        });
      } else {
        this.$refs.userSettingsModal.hide();
      }
    },
  },

  methods: {
    onSave(updatedSettings) {
      this.$store.dispatch('settings/updateSettings', updatedSettings).then(() => {
        this.emitSuccessNotification();
        this.$store.dispatch('settings/closeSettingsModal');
      }).catch(() => {
        this.emitErrorNotification();
      });
    },

    onHidden() {
      this.$store.dispatch('settings/closeSettingsModal');
    },
  },
};
</script>
